import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Loader2 } from "lucide-react";
import { LeafCorner } from "../components/Decorative";

const ImpressumPage = () => {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        api.get("/site-info").then((r) => setInfo(r.data));
    }, []);

    return (
        <div data-testid="impressum-page">
            <section className="relative garden-bg py-16 md:py-20 overflow-hidden">
                <LeafCorner className="absolute top-0 left-0 w-52 h-52 opacity-70" />
                <LeafCorner className="absolute top-0 right-0 w-52 h-52 opacity-70" flip />
                <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center relative">
                    <span className="font-cursive text-2xl text-pastel-pink-dark">~ rechtliches ~</span>
                    <h1 className="font-serif text-4xl sm:text-5xl text-deep-green mt-2">Impressum</h1>
                </div>
            </section>

            <section className="py-12 md:py-16">
                <div className="max-w-3xl mx-auto px-5 sm:px-8">
                    {!info ? (
                        <div className="flex justify-center py-10">
                            <Loader2 className="w-6 h-6 animate-spin text-garden-green" />
                        </div>
                    ) : info.impressum?.trim() ? (
                        <div className="bg-white rounded-3xl p-8 md:p-10 border border-cream-dark shadow-[0_12px_40px_rgba(44,76,59,0.06)]">
                            <div className="font-sans text-deep-green/85 leading-relaxed whitespace-pre-line text-base">
                                {info.impressum}
                            </div>
                        </div>
                    ) : (
                        <div className="bg-cream-dark/40 rounded-2xl p-10 text-center text-deep-green/60">
                            Impressum wurde noch nicht hinterlegt.
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default ImpressumPage;
